<template>
  <div class="protrud-title">
    <div class="vertical-line primary-bg"></div>
    <div class="title m-l-15">{{title}}</div>
  </div>
</template>

<script>
import { ref, reactive, onBeforeMount } from 'vue'
import router from '@/router'
import { getUrlQuery, isUrl } from '@/utils/url.js'
import { fileApi } from '@/apis'

export default {
  props: {
    title: String,
  },
  setup(props, { emit }) {
    return {}
  },
}
</script>

<style lang="scss">
.protrud-title {
  display: flex;
  align-items: center;
  padding: 20px 0 20px 35px;
  .vertical-line {
    width: 6px;
    height: 28px;
  }
  .title {
    font-size: 30px;
  }
}
</style>